// import library
import axios from "axios";
import { useTranslation } from "react-i18next";
// import component
import Layout from "../../layouts/Layout";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import FilterFormLayout from "../../components/Common/Table/FilterFormLayout";
// files
import { env } from "../../env";
import LoaderIcon from "../../components/Common/Icon/Loader";
import AssetNewRequestPopUpComponent from "../../components/Profile/AssestNewRequestPopUpComponent";
import WarningPopUp from "../../components/Profile/WarningPopUp";
import { AuthContext } from "../../context";

const CreateAsset = () => {
    // variables
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const customerid = location.pathname.split('/')[3];
    const [isLoader, setIsLoader] = useState(true);
    const authContext = useContext(AuthContext);
    const storedVisitData = localStorage.getItem('visit');
    const initialVisitData = storedVisitData ? JSON.parse(storedVisitData) : {};
    const [visitTypeData, setVisitTypeData] = useState(initialVisitData);
    const [showWarningPopUp, setShowWarningPopUp] = useState(false);
    
    const [sortTypesList, setSortTypesList] = useState([
        {
            "name" : "name - top to bottom",
            "field" : "name",
            "type" : "asc"
        },
        {
            "name" : "name - bottom to top",
            "field" : "name",
            "type" : "desc"
        },
    ]);

    const [defaultProductImage, setDefaultProductImage] = useState("");
    const [allAssetList, setAllAssetList] = useState([]);

    const [showSort, setShowSort] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showPopUp, setShowPopUp] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");
    const [sortType, setSortType] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortName, setSortName] = useState("");
    const [currentAsset, setCurrentAsset] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            const baseUrl = env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');

            await getDefaultProductImage(baseUrl, token);
            await getAllAssetListApi(baseUrl, token);
        };
        fetchData();
    }, []);
    // tab change
    const handleTabCheckDataFromChild = (data) => {
        if((visitTypeData && visitTypeData.visitId) && data.tab === 'profile') {
            setShowWarningPopUp(!showWarningPopUp)
        } else {
            if(data.link === '/logout') {
                authContext.logout();
            } else {
                navigate(data.link);
            }
            localStorage.removeItem("profile_tab");
        }
    };
    const handleWarningPopUpDataFromChild = (data) => {
        setShowWarningPopUp(!showWarningPopUp);
        if(data === 'complete') {
            setVisitTypeData({});
        }
    };
    // function
    const getDefaultProductImage = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/User/GetDefaultImage",{ headers })
        .then((response) => {
            setDefaultProductImage(response.data.productDefaultImage);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getAllAssetListApi = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Assets/GetAllAssets?customerid=${customerid}`,{ headers })
        .then((response) => {
            setAllAssetList(response.data);
            setIsLoader(false);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const handleSearch = (e) => {
        e.preventDefault();
    };
    const handleShowSort = (e) => {
        e.preventDefault();
        setShowSort(!showSort);
    };
    const handleShowFilter = (e) => {
        e.preventDefault();
        setShowFilter(!showFilter);
    };
    const handleSortType = (e, data) => {
        e.preventDefault();
        setSortName(data.name);
    };
    const handleModalCloseDataFromChild = (data) => {
        setShowPopUp(data);
    };
    const handleShowPopUp = (e, value) => {
        e.preventDefault();
        setCurrentAsset(value);
        setShowPopUp(true);
    };
    
    return (
        <div className="relative">
            <Layout sendTabCheckDataFromChild={handleTabCheckDataFromChild}>
                <div className="flex justify-between items-center">
                    <div className="w-44 sm:w-auto">
                        <h1 className="text-sm sm:text-2xl font-semibold capitalize">{ t('request new asset') }</h1>
                        <div className="text-light-400 text-[10px] w-max sm:w-auto sm:text-sm capitalize flex items-center cursor-pointer"><NavLink to={`/profiles/detail/${customerid}`}>{ t('customer detail') }</NavLink>/{ t('new asset') }</div>
                    </div>
                    <div className="flex justify-between items-center space-x-1 sm:space-x-2">
                        {/* <div className="border border-gray-dark1 cursor-pointer bg-white rounded-lg hidden sm:flex items-center px-4 py-2">
                            <img className="w-4" src="../../../assets/icons/search.svg" alt="search" />
                            <div className="pl-4">
                                <input className="border-none bg-white focus:outline-none w-44 sm:w-32 lg:w-80 placeholder:capitalize" type="text" onKeyDown={(e) => handleSearch(e)} onKeyPress={(e) => handleSearch(e)} placeholder={t('search')+"..."} />
                            </div>
                        </div> */}
                        <div className="flex items-center justify-end space-x-1 sm:space-x-2">
                            <div className="block sm:hidden">
                                <NavLink to={`/profiles/detail/${customerid}`}>
                                    <div className="bg-black-100 flex items-center p-3 sm:p-4 rounded-lg">
                                        <img className="sm:w-3 sm:h-3" src="../../../assets/icons/profile/cancel.svg" alt="cancel" />
                                    </div>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                    <div className="hidden sm:block">
                        <NavLink to={`/profiles/detail/${customerid}`}>
                            <div className="bg-black-100 flex items-center p-3 sm:p-4 rounded-lg">
                                <img className="sm:w-3 sm:h-3" src="../../../assets/icons/profile/cancel.svg" alt="cancel" />
                            </div>
                        </NavLink>
                    </div>
                </div>
                {/* <div className="block sm:hidden bg-white p-2 rounded-lg">
                    <div className="border border-gray-dark1 cursor-pointer bg-white rounded-lg flex items-center py-2 px-2 sm:px-4">
                        <img className="w-4" src="../../../assets/icons/search.svg" alt="search" />
                        <div className="pl-4">
                            <input className="border-none bg-white focus:outline-none w-44 sm:w-32 lg:w-80 placeholder:capitalize" type="text" onKeyDown={(e) => handleSearch(e)} onKeyPress={(e) => handleSearch(e)} placeholder={t('search')+"..."} />
                        </div>
                    </div>
                </div> */}
                { isLoader
                    ?
                        <LoaderIcon />
                    :
                    <>
                        {(allAssetList.length > 0) 
                            ? 
                                <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-2">
                                    {allAssetList.map((asset, index) => (
                                        <div key={`asset${index}`} className="rounded-xl bg-white flex p-2 space-x-2 justify-between shadow-around items-center">
                                            <img className="w-12 h-12 rounded-lg border border-background-normal" src={defaultProductImage} alt="product-img" />
                                            <div className="flex flex-col justify-evenly w-full">
                                                <h1 className="font-semibold text-xs sm:text-base capitalize">{asset.Asset_Descr}</h1>
                                                <div className="flex justify-between space-x-1 items-center">
                                                    <div className="capitalize text-[11px] text-light-700 w-max">{ t('asset code')}<span className="font-medium text-black">: {asset.AssetCode}</span></div>
                                                    <div className="border h-3 border-light-400"></div>
                                                    <div className="flex space-x-1">
                                                        <div className="capitalize text-[10px] sm:text-xs">{asset.Model}</div>
                                                        <div className="capitalize text-[10px] sm:text-xs">{asset.Make}</div>
                                                    </div>
                                                </div>
                                                <div className="capitalize text-[10px] sm:text-xs">
                                                    <div className="capitalize text-[10px] sm:text-xs text-light-700">{ t('s.no.')}<span className="font-medium text-black">: {asset.Serial_no}</span></div>
                                                </div>
                                            </div>
                                            <img onClick={(e) => handleShowPopUp(e, asset)} className="cursor-pointer"  src="../../../assets/icons/profile/plus_light.svg" alt="plus_light" />
                                        </div>
                                    ))}
                                </div>
                            :
                                <div className="p-4 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white">
                                    { t('no records available')}
                                </div>
                        }
                    </>
                }
            </Layout>
            {/* page */}
            {showPopUp && <AssetNewRequestPopUpComponent currentAsset={currentAsset} customerId={customerid} sendModalCloseDataFromChild={handleModalCloseDataFromChild} />}
            {/* common */}
            {showWarningPopUp && <WarningPopUp customerId={customerid} visitTypeData={visitTypeData} sendWarningPopUpDataFromChild={handleWarningPopUpDataFromChild} /> }
        </div>
    )
}

export default CreateAsset;